import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const PublicFormPage = lazy(() => import("@/pages/PublicFormPage"));

export const Route = createFileRoute("/f/$slug")({
  component: PublicFormRoute,
});

function PublicFormRoute() {
  return (
    <Suspense fallback={null}>
      <PublicFormPage />
    </Suspense>
  );
}
